import { useEffect, useState } from "react";
import { ip as ipReq } from "sources/home";

export default function Ip() {
    const [ip, setIp] = useState("");
    useEffect(() => {
        ipReq().then((res) => {
            if (res) {
                setIp(res.ip);
            }
        });
    }, []);

    return ip;
}
